import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO16 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK001-6.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO16
